import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { fmtTime } from "@/lib/sourceMeta";

export const EmailCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/email").then((r) => setS(r.data ?? null)).catch(() => setS(null)); }, []);

  const save = async (patch) => {
    const next = { enabled: s.enabled, email_to: s.email_to, ...patch };
    try { const { data } = await api.put("/settings/email", next); setS(data); toast.success(next.enabled ? `Morning brief will go to ${data.email_to}` : "Morning emails turned off"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  if (!s) return null;
  return (
    <article data-testid="email-settings-card" className="rounded-2xl bg-surface border border-slate-200 p-5 sm:p-6 lg:col-span-2">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-orange-50 text-brand"><MailCheck className="w-5 h-5" /></span>
          <div><h3 className="font-semibold text-slate-900">Morning email</h3><p className="text-sm text-slate-500">Get the 07:00 brief straight in your inbox.</p></div>
        </div>
        <Switch data-testid="email-enabled-switch" checked={s.enabled} onCheckedChange={(v) => save({ enabled: v })} />
      </div>
      <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <label className="text-sm text-slate-600 shrink-0" htmlFor="email-to">Send to</label>
        <select id="email-to" data-testid="email-to-select" value={s.email_to} onChange={(e) => save({ email_to: e.target.value })}
          className="w-full sm:w-auto rounded-xl border border-slate-300 bg-surface px-3 py-2.5 text-sm outline-none focus:border-teal-600">
          {(s.allowed ?? []).map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <span data-testid="email-last-sent" className="text-xs text-slate-500">{s.last_error ? <span className="text-rose-600">Last send failed: {s.last_error}</span> : s.last_sent_at ? `Last sent ${fmtTime(s.last_sent_at)}` : "Nothing sent yet"}</span>
      </div>
    </article>
  );
};
